import { Tab, withStyles } from '@material-ui/core';

export default withStyles({
  root: {
    textTransform: 'none',
    fontWeight: 'normal',
    color: '#868585',
  },
})(Tab);
